module.exports = __webpack_public_path__ + "fonts/trust_sans_regular-webfont.47fc0508.woff2";